import classNames from 'classnames';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = exact({
  autoComplete: PropTypes.string,
  blockName: PropTypes.string,
  fieldName: PropTypes.string,
  fieldValue: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  inputType: PropTypes.string,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  isValid: PropTypes.bool,
  modifier: PropTypes.string,
  maxLength: PropTypes.number,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  placeholderText: PropTypes.string,
});

const defaultProps = {
  autoComplete: undefined,
  blockName: null,
  fieldName: null,
  fieldValue: '',
  inputType: 'text',
  isDisabled: false,
  isInvalid: false,
  isRequired: false,
  isValid: false,
  maxLength: null,
  modifier: 'ghost',
  onKeyDown: undefined,
  onBlur: undefined,
  placeholderText: null,
};

function Input(props) {
  const inputClasses = classNames(props.blockName, 'Input', `Input-${props.modifier}`, {
    disabled: props.isDisabled,
    invalid: props.isInvalid,
    valid: props.isValid,
  });

  return (
    <input
      autoComplete={props.autoComplete}
      type={props.inputType}
      name={props.fieldName}
      value={props.fieldValue}
      disabled={props.isDisabled}
      required={props.isRequired}
      onChange={props.handleChange}
      placeholder={`${props.placeholderText}${props.isRequired ? '*' : ''}`}
      className={inputClasses}
      maxLength={props.maxLength}
      onBlur={props.onBlur}
      onKeyDown={props.onKeyDown}
      min={props.inputType === 'number' ? 0 : undefined}
    />
  );
}

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;

export default Input;
